/**
 * Maps a workflow's module / record_type to the in-app route that shows that
 * record, so workflow tables can deep-link to the underlying record.
 * Returns null when there is no known viewer for the module (caller renders
 * the id as plain text instead of a broken link).
 */
const VIEWERS = {
  sales: (id) => `/print/sales/${id}`,
  quotation: (id) => `/print/quotation/${id}`,
};

export function recordViewPath(moduleOrType, recordId) {
  if (!recordId) return null;
  const fn = VIEWERS[moduleOrType];
  return fn ? fn(recordId) : null;
}
